export enum ExpenseTypes {
  SALARY = "Зарплата",
  FEES = "Гонорари",
  RENT = "Оренда",
  Meals = "Харчування",
  MARKETING = "Маркетинг",
  PURCHASES = "Закупівлі",
  LOGISTICS = "Логістика",
  BILLS = "Комунальні послуги",
  TAXES = "Податки",
  OTHER = "Інше",
}

export enum IncomeTypes {
  PAYMENT = "Оплата від клієнта",
  ADVANCE = "Аванс",
  PREPAYMENT = "Передоплата",
  GRANT = "Грант",
  SUBSIDY = "Субсидія",
  CREDIT = "Кредит",
  LOAN = "Позика",
  INVESTMENT = "Інвестиція",
  REFUND = "Повернення коштів",
  OTHER = "Інше",
}

export enum FinanceTypeTable {
  EXPENSE = "Витрати",
  INCOME = "Надходження",
}
